import { createContext, useCallback, useContext, useEffect, useMemo } from 'react';
import { useUiPrefs } from '../hooks/useUiPrefs.js';

const ThemeModeContext = createContext({ mode: 'light', palette: 'light', toggle: () => {} });

/**
 * Жарык/караңгы тема. Тандоо колдонуучунун аккаунтунда (`prefs.themeMode`),
 * кире электе (логин бети) — жарык.
 */
export function ThemeModeProvider({ children }) {
  const { themeMode: mode, textScale, setPref } = useUiPrefs();

  useEffect(() => {
    document.documentElement.dataset.theme = mode;
  }, [mode]);

  const toggle = useCallback(() => setPref({ themeMode: mode === 'light' ? 'dark' : 'light' }), [mode, setPref]);
  const value = useMemo(() => ({ mode, palette: mode, textScale, toggle }), [mode, textScale, toggle]);
  return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
}

export const useThemeMode = () => useContext(ThemeModeContext);
